export default "__VITE_ASSET__BWeX8X1s__"